/* =========================================================
   tm-modal.js
   - Newsletter modal open/close (data-tm-newsletter-open / data-tm-modal-close)
   - Toast + voucher + copy button + pause-on-hover
   - Newsletter success toast after reload (.tm-nl__status--ok)
   - Auto-open newsletter on homepage + product pages (waits for modal)
   ========================================================= */

/* ===== Modal open/close ===== */
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-tm-newsletter-open]');
  const close = e.target.closest('[data-tm-modal-close]');
  const modal = document.getElementById('tm-newsletter');
  if (!modal) return;

  if (open) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    return;
  }

  if (close) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
});

/* ===== Toast helpers ===== */
function TMToast(msg, opts = {}) {
  const toast = document.getElementById('tm-toast');
  const text = document.getElementById('tm-toast-msg');
  if (!toast || !text) return;

  const {
    duration = 12000,
    voucher = '',     // e.g. "TALMEA10"
    autoCopy = false  // true => try copy immediately
  } = opts;

  // Build content
  if (voucher) {
    text.innerHTML = `
      <span class="tm-toast__text">${String(msg)}</span>
      <span class="tm-toast__voucher">
        <span class="tm-toast__code">${voucher}</span>
        <button type="button" class="tm-toast__copy" data-tm-toast-copy>
          Kopieren
        </button>
      </span>
    `;
  } else {
    text.textContent = msg;
  }

  toast.hidden = false;
  toast.classList.add('is-visible');

  const startTimer = () => {
    window.clearTimeout(window.__tmToastTimer);
    window.__tmToastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => { toast.hidden = true; }, 250);
    }, duration);
  };

  const stopTimer = () => window.clearTimeout(window.__tmToastTimer);

  // pause on hover (bind once)
  if (!toast.__tmHoverBound) {
    toast.addEventListener('mouseenter', stopTimer, { passive: true });
    toast.addEventListener('mouseleave', startTimer, { passive: true });
    toast.__tmHoverBound = true;
  }

  // copy handler (bind once)
  if (!toast.__tmCopyBound) {
    toast.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-tm-toast-copy]');
      if (!btn) return;

      const codeEl = toast.querySelector('.tm-toast__code');
      const code = codeEl ? codeEl.textContent.trim() : '';
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        btn.textContent = 'Kopiert';
        btn.disabled = true;
        window.setTimeout(() => {
          btn.textContent = 'Kopieren';
          btn.disabled = false;
        }, 1600);
      } catch (err) {
        // fallback: select code for manual copy
        if (codeEl) {
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    });
    toast.__tmCopyBound = true;
  }

  startTimer();

  // optional auto-copy (best effort; some browsers require user gesture)
  if (voucher && autoCopy) {
    window.setTimeout(async () => {
      try { await navigator.clipboard.writeText(voucher); } catch (e) {}
    }, 50);
  }
}

/* Close toast (X) */
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-tm-toast-close]')) return;
  const toast = document.getElementById('tm-toast');
  if (!toast) return;
  toast.classList.remove('is-visible');
  window.setTimeout(() => { toast.hidden = true; }, 250);
});

/* ===== Newsletter success after reload ===== */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('tm-newsletter');
  if (!modal) return;
/* Voucher Version
  const ok = modal.querySelector('.tm-nl__status--ok');
  if (ok) {
    TMToast('Danke! Du bist jetzt angemeldet. Dein Gutschein:', {
      voucher: 'TALMEA10',
      duration: 12000,
      autoCopy: true
    });

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
});
*/

const ok = modal.querySelector('.tm-nl__status--ok');
  if (ok) {
    TMToast('Vielen Dank für deine Anmeldung! Du erhältst ab sofort unsere Newsletter per E-Mail.', {
      duration: 12000
    });

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
});
/* ===== Newsletter auto-open on home + product ===== */
document.addEventListener('DOMContentLoaded', () => {
  const KEY = 'tm_newsletter_autopopup_v1';

  const isHome = () => {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/';
  };

  const isProduct = () => {
    return !!(document.querySelector('form[action*="/cart/add"]') && document.querySelector('[name="id"]'));
  };

  const shouldAutoOpen = () => isHome() || isProduct();

  const openModal = (modal) => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  };

  const tryOpen = () => {
    const modal = document.getElementById('tm-newsletter');
    if (!modal) return false;

    if (!shouldAutoOpen()) return true;

    if (sessionStorage.getItem(KEY)) return true;
    sessionStorage.setItem(KEY, '1');

    window.setTimeout(() => openModal(modal), 1200);
    return true;
  };

  if (tryOpen()) return;

  const observer = new MutationObserver(() => {
    if (tryOpen()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});